module.exports = __webpack_public_path__ + "static/media/annual-salary-revision.78d0f86e.svg";